import React from 'react';
import {
  Button, ButtonColor, ButtonProps, Grid, SpacingName, TypographyName,
} from '@doveit/lego';
import { BasicSectionProps } from '../types';
import PageSection from '../../components/page-section/PageSection';
import Markdown from '../../components/markdown/Markdown';
import BasicStripe, { BasicStripeProps } from '../../components/basic-stripe-2/BasicStripe';

type ExtendedButton = ButtonProps & { dataRef?: string, dataTracking?: string };

export interface StripesSectionProps extends BasicSectionProps {
  items: BasicStripeProps[],
  actions?: ExtendedButton[],
  showAsGrid?: boolean,
}

export const StripesSection: React.FC<StripesSectionProps> = ({
  title,
  content,
  items,
  actions = [],
  showAsGrid = false,
}) => (
  <PageSection>
    <PageSection.Wrapper>
      {title && (
        <PageSection.Title>
          <Markdown>
            {title.trim()}
          </Markdown>
        </PageSection.Title>
      )}
      {content && (
        <PageSection.Description
          text={content.trim()}
          size={TypographyName.H4}
        />
      )}
      <PageSection.Block>
        <Grid gutter={SpacingName.SMALL}>
          {items.map((item) => (
            <Grid.Unit
              key={item.title}
              size={showAsGrid ? { MD: 1 / 2 } : 1}
            >
              <BasicStripe {...item} />
            </Grid.Unit>
          ))}
        </Grid>
      </PageSection.Block>
      {actions.length > 0 && (
        <PageSection.Actions>
          {actions.map((action) => (
            <Button
              {...action}
              key={action.label}
              color={ButtonColor.PRIMARY}
            />
          ))}
        </PageSection.Actions>
      )}
    </PageSection.Wrapper>
  </PageSection>
);

export default StripesSection;
